import { render, staticRenderFns } from "./DependencyFilterStructure.vue?vue&type=template&id=5a31ac40&scoped=true&"
import script from "./DependencyFilterStructure.vue?vue&type=script&lang=js&"
export * from "./DependencyFilterStructure.vue?vue&type=script&lang=js&"
import style0 from "./DependencyFilterStructure.vue?vue&type=style&index=0&id=5a31ac40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a31ac40",
  null
  
)

export default component.exports